export class PropertyInfoObj {

    /**
     * Starting value of the tweening (null if not started yet)
     */
    public valueStart: number;
    /**
     * Final desired value
     */
    public valueComplete: number;
    /**
     * Final desired value as declared initially
     */
    public originalValueComplete: any;
    /**
     * Index (if this is an array item)
     */
    public arrayIndex: number;
    /**
     * Additional parameters, used by some special properties
     */
    public extra: any;
    /**
     * Whether or not this is a special property instead of a direct one
     */
    public isSpecialProperty: boolean;
    /**
     * Whether or not it has a modifier function
     */
    public hasModifier: boolean;
    /**
     * Modifier function, if any
     */
    public modifierFunction: Function;
    /**
     * Additional array of modifier parameters
     */
    public modifierParameters: any[];

    // ==================================================================================================================================
    // CONSTRUCTOR function -------------------------------------------------------------------------------------------------------------

    /**
     * Initializes the basic PropertyInfoObj.
     *
     * @param obj
     */
    constructor(obj: Partial<Omit<PropertyInfoObj, 'hasModifier'>>) {
        this.valueStart = obj.valueStart;
        this.valueComplete = obj.valueComplete;
        this.originalValueComplete = obj.originalValueComplete;
        this.arrayIndex = obj.arrayIndex;
        this.extra = obj.extra;
        this.isSpecialProperty = obj.isSpecialProperty;
        this.hasModifier = (obj.modifierFunction != null);
        this.modifierFunction = obj.modifierFunction;
        this.modifierParameters = obj.modifierParameters;
    }


    // ==================================================================================================================================
    // OTHER functions ------------------------------------------------------------------------------------------------------------------

    /**
     * Clones this property info and returns the new PropertyInfoObj
     *
     * @return A copy of this object
     */
    public clone(): PropertyInfoObj {
        return new PropertyInfoObj(this);
    }

    /**
     * Returns this object described as a string.
     *
     * @return The description of this object.
     */
    public toString(): string {
        let returnStr: string = '\n[PropertyInfoObj ';
        returnStr += 'valueStart:' + this.valueStart;
        returnStr += ', ';
        returnStr += 'valueComplete:' + this.valueComplete;
        returnStr += ', ';
        returnStr += 'originalValueComplete:' + this.originalValueComplete;
        returnStr += ', ';
        returnStr += 'arrayIndex:' + this.arrayIndex;
        returnStr += ', ';
        returnStr += 'extra:' + this.extra;
        returnStr += ', ';
        returnStr += 'isSpecialProperty:' + this.isSpecialProperty;
        returnStr += ', ';
        returnStr += 'hasModifier:' + this.hasModifier;
        returnStr += ', ';
        returnStr += 'modifierFunction:' + this.modifierFunction;
        returnStr += ', ';
        returnStr += 'modifierParameters:' + this.modifierParameters;
        returnStr += ']\n';
        return returnStr;
    }
}
